<template>
  <div>
    <div class="accountsetCount" style="min-width:1046px">
      <div class="box-shadow top-box">
        <div class="global-title">签名报备</div>
      </div>
      <div style="margin-top: 10px; padding: 26px">
        <el-alert class="alert" type="warning" :closable="false">
          <template slot="title">
            <div style="color: #333333">
               <img

          src="@/assets/images/new_icon_waring_yellow.png"
          style="
            display: inline-block;
            position: absolute;
            width: 14px;
            height: 14px;
            color: #ffffff;
            margin: 2px 0px 0 0px;
          "
        />
              <div style="margin:0px 20px"
                >根据京东服务市场最新规则，短信签名不得包含【京东】、【京东金融】、【京东云】、【京东到家】、【拍拍】、【易迅】、【京东支付】、【1号店】，详情请咨询在线客服
              <a
                href="tencent://message/?uin=800152084&Site=在线客服&Menu=yes"
                target="_blank"
              >
                <span  class="qqSay">QQ交谈</span>
              </a></div
              >
            </div>
          </template>
        </el-alert>
        <div class="table-box" style="margin-top: 20px">
          <div class="button-box">
            <div class="float-left-button" style="margin-bottom: 10px">
              <div
                class="button"
                v-zoom='{from:pageName,name:"添加签名"}'
                @click="handleAdd"
                :style="{
                  background: changeColor,
                  'border-color': changeColor,
                }"
              >
                <span class="button-title" style="color: #fff">
                  <img
                    src="@/assets/images/member/new_establish.png"
                    style="
                      display: inline-block;
                      float: left;
                      width: 14px;
                      height: 14px;
                      margin-right: 4px;
                    "
                  />添加签名
                </span>
              </div>
            </div>
          </div>
          <el-table
            ref="multipleTable"
            :data="tableData"
            border
            tooltip-effect="light"
            :header-cell-style="{
              background: '#FAFAFA',
              color: '#3C4560',
            }"
            style="width: 100%; border: 1px solid #eee"
            v-loading="talbeLoading"
          >
            <template slot="empty">
              <div>
                <img src="@/assets/images/default/暂无任何数据.png" />
                <span style="margin-left: -140px">暂无任何数据</span>
              </div>
            </template>
            <el-table-column
              align="center"
              prop="suffix"
              label="短信签名"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.suffix }}</span
                >&nbsp;
                <!-- <span v-if="0 == scope.$index " class="default" >默认</span> -->
                <span v-if="scope.row.isDefault == true" class="default"
                  >默认</span
                >
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="optime"
              label="最后修改时间"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="suffixType"
              label="类型"
            ></el-table-column>
            <el-table-column align="center" prop="status" label="审核状态" width="100px">
              <template slot-scope="scope">
                <span v-if="scope.row.status == 1">
                  <span
                    class="dot"
                    :class="scope.row.status == '1' ? 'dot-0' : ''"
                  ></span>
                  {{ scope.row.status | statusStr }}
                </span>

                <span v-else-if="scope.row.status == 0">
                  <span
                    class="dot"
                    :class="scope.row.status == '0' ? 'dot-2' : ''"
                  ></span>
                  {{ scope.row.status | statusStr }}
                </span>

                <span v-else-if="scope.row.status == 2">
                  <span
                    class="dot"
                    :class="scope.row.status == '2' ? 'dot-1' : ''"
                  ></span>
                  {{ scope.row.status | statusStr }}
                  <el-popover
                    placement="top-start"
                    width="200"
                    trigger="hover"
                    :content="scope.row.remark"
                  >
                    <span slot="reference" class="icon_ii">?</span>
                  </el-popover>
                </span>
                <span v-else>{{ scope.row.status }}</span>

                <!-- <span v-if="scope.row.status= 1" class="auditSuccessful">审核成功</span>
                <span v-else-if="scope.row.status= 0 " class="underReviewCenter">审核中</span>
                <span v-else-if="scope.row.status= 2 " class="underReview">审核拒绝</span>
                <span v-else>{{scope.row.status}}</span>-->
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="bindDate"
              label="操作"
              width="400px"
            >
              <template slot-scope="scope">
                <!-- 状态为默认已通过 -->
                <div
                  v-if="scope.row.status == 1 && 0 != scope.$index"
                  @mouseenter="nthDefault = scope.$index"
                  @mouseleave="nthDefault = 0"
                >
                  <el-button
                    v-if="scope.row.suffixType == '自定义'"
                    @click="handleEdit(scope.$index, scope.row)"
                    type="text"
                    v-zoom='{from:pageName,name:"编辑"}'
                    class="operation"
                    >编辑</el-button
                  >&nbsp;
                  <el-button
                    v-if="scope.row.suffixType == '自定义'"
                    @click="handleDelete1(scope.$index, scope.row)"
                    v-zoom='{from:pageName,name:"删除"}'
                    type="text"
                    class="operation"
                    >删除</el-button
                  >&nbsp;
                  <el-button
                    @click="handleDefault(scope.$index, scope.row)"
                    v-if="nthDefault == scope.$index && scope.$index != 0"
                    type="text"
                    v-zoom='{from:pageName,name:"默认"}'
                    class="operation"
                    >默认</el-button
                  >
                </div>
                <div v-if="scope.row.status == 2">
                  <el-button
                    @click="handleConfirm(scope.$index, scope.row)"
                    type="text"
                    v-zoom='{from:pageName,name:"重新提交"}'
                    class="operation"
                    >重新提交</el-button
                  >
                </div>
                <!-- 状态为审核中-->
                <div v-if="scope.row.status == 0">
                  <el-button
                    @click="handleEdit(scope.$index, scope.row)"
                    type="text"
                    v-zoom='{from:pageName,name:"审核中编辑"}'
                    class="operation"
                    >编辑</el-button
                  >&nbsp;
                  <el-button
                    @click="handleDelete1(scope.$index, scope.row)"
                    type="text"
                    v-zoom='{from:pageName,name:"审核中删除"}'
                    class="operation"
                    >删除</el-button
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="footerClassOne">
          <div>
            <img
              src="../../assets/images/new_icon_reminder.png"
              style="
                display: inline-block;
                float: left;
                width: 14px;
                height: 14px;
                color: #ffffff;
                margin: 4px 4px 0px 8px;
              "
            />1.签名需为4~12位，只能由中英文或数字组成，但不能纯英文、纯数字；
          </div>
          <div style="margin-left: 25px">
            2.发短信时，系统会将短信与签名组合一起发送到客户手机上；
          </div>
          <div style="margin-left: 25px">
            3.亲，新申请的签名请联系客服进行审核；
          </div>
          <div style="margin-left: 25px">4.最多只能提交5个自定义签名</div>
        </div>
        <div style="height: 200px"></div>
      </div>
      <!-- 添加签名弹框 -->
      <el-dialog
        title="创建签名"
        :visible.sync="showDialog"
        width="340px"
        style="min-width: 1200px"
      >
        <template slot="title">
          <span>{{ cusuffixName }}</span>
        </template>
        <div class="dialog-wrapper">
          <div class="item">
            <span class="item-title">签名：</span>
            <el-input
              size="small"
              class="input"
              v-model="addSeller"
              @input="cusuffixChange"
            ></el-input>
          </div>
          <!-- <div class="item">
            <span class="item-title">优先级：</span>
            <el-input-number
              v-model="addSellerCusuffixNum"
              controls-position="right"
              :min="0"
              :max="10"
              class="input"
              size="small"
              v-if="addSellerCusuffixNum == 0"
            ></el-input-number>
            <el-input-number
              controls-position="right"
              :min="1"
              :max="10"
              class="input"
              size="small"
              v-else
              v-model="addSellerCusuffixNum"
            ></el-input-number>
          </div>-->
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button
            showDialog="showDialog"
            style="width: 96px"
            @click="showDialog = false"
            >取消</el-button
          >
          <el-button @click="submitAudit" type="primary" style="width: 96px"
            >提交</el-button
          >
        </span>
      </el-dialog>
    </div>
    <!-- 删除弹框 -->
    <el-dialog
      title="提示"
      :visible.sync="outerVisible"
      width="400px"
      :before-close="closehandleDelete"
      ><img
        src="@/assets/images/tips_icon.png"
        class="tips"
        style="margin: 6px 0px 0px 40px; position: absolute;width:22px"
      />
      <span
        style="position: absolute; margin: 10px 0px 0px 140px; font-size: 14px"
        >此操作将永久删除该签名, 是否继续?</span
      >
      <span slot="footer" class="buttonBox">
        <el-button class="b1" @click="closehandleDelete">取 消</el-button>
        <el-button class="b2" @click="handleDeleteTable">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>
<script>
import {
  insert,
  delectCount,
  queryAllSellerCusuffix,
  reput,
  editCount,
  def,
} from "@/api/backstage/storeAutograph";
import { mapState, mapMutations } from "vuex";
export default {
  name: "signature_set",
  computed: {
    ...mapState({
      changeColor: "globalBG",
    }),
    addSeller: {
      get() {
        return this.addSellerCusuffix.replace(/[【】]/g, "");
      },
      set() {},
    },
  },
  components: {},
  filters: {
    statusStr(status) {
      return { 0: "审核中", 1: "已通过", 2: "未通过", null: "null" }[status];
    },
  },
  data() {
    return {
      pageName:"后台管理-签名报备",
      talbeLoading: false,
      nthDefault: 0,
      showDialog: false, //添加签名弹窗
      cusuffixName: "添加签名", //签名状态（添加/删除/编辑/默认）,
      tableData: [],
      addSellerCusuffix: "", //短信签名内容
      addSellerCusuffixNum: "", //优先级,
      handleEditOb: {}, //编辑
      editId: "", //编辑修改ID
       outerVisible:false,
       index1:"",
       row1:"",
    };
  },
  created() {
    // 埋点
    this.buriedPoint(1, '店铺签名', '后台管理', '签名管理')
  },
  mounted() {
    this.queryAllSellerCusuffix();
  },
  methods: {
    //添加标签提交
    submitAudit() {
      if (
        this.addSellerCusuffix.length < 4 ||
        12 < this.addSellerCusuffix.length
      ) {
        this.$message("自定义签名字数限制4-12位");
        return;
      }
      if (this.cusuffixName == "编辑签名") {
        this.submitEdit();
        return;
      }
      if (this.tableData.length == 6) {
        this.$message("最多只能提交5个自定义签名");
        this.$message("最多只能提交5个自定义签名");
        this.$message("最多只能提交5个自定义签名");
        return;
      }
      var reg = new RegExp(/[A-Za-z].*[0-9]|[0-9].*[A-Za-z]|[\u4e00-\u9fa5]/);
      if (!reg.test(this.addSellerCusuffix)) {
        this.$message("签名只能由中英文或数字组成，但不能纯英文、纯数字");
        return;
      }
      insert({
        suffix: this.addSellerCusuffix,
      })
        .then((res) => {
          if (res.code == 200) {
          }
          this.showDialog = false;
          this.queryAllSellerCusuffix();
        })
        .catch((e) => {});
    },
    //添加签名
    handleAdd() {
      this.cusuffixChange("");
      this.addSellerCusuffixNum = 2;
      this.cusuffixName = "添加签名";
      this.showDialog = true;
    },
    //表格查询
    queryAllSellerCusuffix() {
      this.talbeLoading = true;
      queryAllSellerCusuffix({
        size: 10,
        current: 1,
      })
        .then((res) => {
          console.log(res);
          this.talbeLoading = false;
          this.tableData = res.data;
          console.log(this.tableData);
        })
        .catch(() => {
          this.talbeLoading = false;
        });
    },
    // queryList() {
    //   getBuyerLabelByLabelName(this.formDataList)
    //     .then((res) => {
    //       this.tableData = res.data.records;
    //       this.totalNum = res.data.total;
    //       console.log(res.data);
    //     })
    //     .catch((res) => {});
    // },
    handleDelete1(index, row){
       this.outerVisible=true;
       this.index1=index;
       this.row1=row;
    },
    //关闭删除弹框
    closehandleDelete() {
      this.outerVisible = false;
      this.$message.warning("已关闭删除");
    },
     //确认删除
    handleDeleteTable(){
      this.outerVisible = false;
      this.handleDelete(this.index1,this.row1);
    },
    //删除
    
    handleDelete(index, row) {
      this.cusuffixName = "删除签名";
      // this.$confirm("此操作将永久删除该签名, 是否继续?", "提示", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   iconClass:"iconfont iconicon-jinggao1",
      // })
        // .then(() => {
          delectCount({
            id: row.id,
          })
            .then((res) => {
              this.tableData.splice(index, 1);
            })
            .catch((e) => {});
             this.queryAllSellerCusuffix();
          this.$message({
            type: "success",
            message: "删除成功!",
          })
         
        // })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //重新提交
    handleConfirm(index, row) {
      reput({ id: row.id })
        .then((res) => {
          this.$message({
            message: "更新成功",
            type: "success",
          });
          this.queryAllSellerCusuffix();
        })
        .catch((e) => {});
    },
    //设置默认
    handleDefault(index, row) {
      def({ id: row.id })
        .then((res) => {
          this.$message({
            message: "默认成功",
            type: "success",
          });
          this.queryAllSellerCusuffix();
        })
        .catch((e) => {});
    },
    //编辑时间提交
    submitEdit() {
      this.addSellerCusuffix = this.addSellerCusuffix.replace(/[【】]/g, "");
      editCount({
        suffix: this.addSellerCusuffix,
        id: this.editId,
      }).then((res) => {
        this.showDialog = false;
        this.$message({
          message: "编辑成功",
          type: "success",
        });
        this.queryAllSellerCusuffix();
      });
    },
    //编辑
    handleEdit(index, row) {
      this.editId = row.id;
      if (row.status === "审核中") {
        this.handleEditOb.status = 0;
      } else {
        this.handleEditOb.status = "";
      }
      this.handleEditOb.index = index;
      this.handleEditOb.row = row;
      this.addSellerCusuffix = row.suffix;
      this.addSellerCusuffixNum = row.priority;
      this.cusuffixName = "编辑签名";
      this.showDialog = true;
    },
    //签名时赋值
    cusuffixChange(value) {
      this.addSellerCusuffix = value.replace(/[【】]/g, "");
    },
  },
};
</script>
<style lang="scss">
.el-dialog__header span {
  font-size: 16px !important;
  color: #333333 !important;
  width: 64px;
  height: 22px;
  font-weight: 600 !important;
  line-height: 28px;
  opacity: 1;
}

.operation{
  cursor: pointer;
                  color: #7f85e9;
                  &:hover {
                    color: #fe4d45;
                  }
}
.buttonBox {
  .b1 {
    width: 98px;
    height: 32px;
    color: #666666;
    // position: absolute;
    border-radius: 3px;
    margin-top: 20px;
    border: 1px solid #dddddd;
    background-color: #fff;
    &:hover {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
    &:active {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
  }
  .b2 {
    width: 98px;
    // position: absolute;
    // margin-right: 80px;
    height: 32px;
    margin:20px  80px  10px 10px ;
    border: 1px solid #fe4d45;
    color: #ffffff;
    border-radius: 3px;
    background-color: #fe4d45;
    &:hover {
      color: #fff;
      opacity: 0.9;
      background-color: #fe4d45;
    }
    &:active {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
  }
}
.el-dialog .el-dialog__header {
  background-color: #fff;
  border-bottom: 1px solid #f3f3f3;
}
.el-dialog__body {
  padding: 16px 20px;
}
</style>
<style lang="scss" scope>
/deep/ .el-dialog {
  height: 220px !important;
}
.accountsetCount {
  min-width: 1100px;
  background: #fff;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  border-radius: 6px;
  border: 1px solid rgba(230, 230, 230, 1);
  box-shadow: 0px 4px 12px rgba(221, 221, 221, 0.3);
  opacity: 1;
  margin: 10px 20px 20px 20px;
  box-shadow: 0px 4px 12px rgba(221, 221, 221, 0.3);
  .icon_i {
    display: inline-block;
    position: absolute;
    width: 14px;
    height: 14px;
    border-radius: 14px;
    background-color: #ffb95e;
    color: #fff;
    font-size: 10px;
    text-align: center;
    line-height: 14px;
    font-weight: bold;
    margin: 2px 0 0 -12px;
  }
  .title {
    width: 84px;
    height: 16px;
    font-size: 16px;
    // font-family: PingFang SC;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
  }
  .qqSay {
    width: 50px;
    height: 16px;
    background: linear-gradient(89deg, #63b6ff 0%, #3b6eff 100%);
    opacity: 1;
    border-radius: 2px;
    padding: 1px 7px;
    color: #fff;
    font-size: 12px;
    // margin-left: 5px;
    margin-right: 12px;
    cursor: pointer;
  }
  .line {
    width: 100%;
    height: 1px;
    background: rgba(243, 243, 243, 1);
    border-radius: 1px;
    margin-top: 5px;
  }
  .electricFan {
    height: 110px;
    background: rgba(248, 250, 255, 1);
    border: 1px solid rgba(172, 193, 254, 1);
    border-radius: 2px;
    margin-top: 15px;
    color: #333333;
    padding-left: 52px;
    padding-top: 1%;
    .iconPublic {
      width: 20px !important;
      height: 20px !important;
      display: inline-block;
    }
  }
  .table-box {
    .icon_ii {
      display: inline-block;
      width: 14px;
      height: 14px;
      border-radius: 14px;
      color: #cccccc;
      font-size: 14px;
      text-align: center;
      line-height: 12px;
      font-weight: bold;
      top: 18px;
      left: 16px;
      border: 1px solid #cccccc;
    }
    .item {
      margin-bottom: 15px;
      display: inline-block;
      vertical-align: middle;
      color: #666;
      font-size: 14px;
      margin-right: 42px;
      .item-name {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 19px;
        display: inline-block;
      }
      .long-input {
        width: 150px;
        display: inline-block;
      }
    }
  }
  .button-box {
    margin-bottom: 10px;
    .float-left-button {
      float: left;
      .button {
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        display: inline-block;
        vertical-align: middle;
        padding: 0 16px;
        border: 1px solid #2062e7;
        color: #2062e7;
        font-size: 14px;
        min-width: 96px;
        -webkit-border-radius: 2px;
        -moz-border-radius: 2px;
        border-radius: 2px;
        margin-right: 10px;
        margin-bottom: 12px;
        cursor: pointer;
        &:hover {
          opacity: 0.9;
        }
        &:active {
          // background-color: #3d6fff !important;
          color: #fff;
        }
        .button-icon {
          display: inline-block;
          vertical-align: middle;
          margin-right: 8px;
        }
        .button-title {
          display: flex;
          align-items: center;
          line-height: 30px;
        }
      }
    }
  }
  .dialog-wrapper {
    .item {
      margin-bottom: 8px;
      .item-title {
        display: inline-block;
        vertical-align: middle;
        // width: 60px;
        text-align: right;
      }
      .input {
        display: inline-block;
        vertical-align: middle;
        width: 80%;
      }
    }
  }
  .default {
    width: 36px;
    // height: 16px;
    background: #fe4d45;
    box-shadow: 0px 3px 6px rgba(88, 130, 251, 0.3);
    opacity: 1;
    border-radius: 14px;
    color: #ffffff;
    font-size: 12px;
    padding: 1px 8px;
  }
  .dot {
    display: inline-block;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    opacity: 1;
    margin-right: 7px;
  }
  .dot-0 {
    background: #49c568;
  }
  .dot-1 {
    background: #fe4d45;
  }
  .dot-2 {
    background: #ffb95e;
  }
  // .auditSuccessful {
  //   width: 76px;
  //   height: 28px;
  //   background: rgba(243, 247, 254, 1);
  //   opacity: 1;
  //   border-radius: 4px;
  //   font-size: 14px;
  //   color: #5882fb;
  //   padding: 4px 10px;
  // }
  // .underReview {
  //   width: 76px;
  //   height: 28px;
  //   background: #fbecea;
  //   opacity: 1;
  //   border-radius: 4px;
  //   font-size: 14px;
  //   color: #fd695b;
  //   padding: 4px 10px;
  // }
  // .underReviewCenter {
  //   width: 76px;
  //   height: 28px;
  //   background: #f6f6f6;
  //   opacity: 1;
  //   border-radius: 4px;
  //   font-size: 14px;
  //   color: #666666;
  //   padding: 4px 10px;
  // }
  .footerClassOne {
    padding: 14px 12px;
    // height: 86px;
    background: rgba(250, 250, 250, 1);
    opacity: 1;
    font-size: 14px;
    color: rgba(51, 51, 51, 1);
    font-weight: 400;
    line-height: 21px;
    position: relative;
    margin-top: 40px;
    .icon_i {
      display: inline-block;
      position: absolute;
      width: 14px;
      height: 14px;
      border-radius: 14px;
      background-color: #fe8f8a;
      color: #fff;
      font-size: 14px;
      text-align: center;
      line-height: 14px;
      font-weight: bold;
      top: 18px;
      left: 16px;
    }
  }
}
</style>
